import { Box, Button, Card, Grid, Modal, Typography, FormLabel } from "@mui/material";
import MDAvatar from "components/MDAvatar";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import React, { useRef, useState, useEffect, useMemo } from "react";
import EditIcon from "@mui/icons-material/Edit";
import ChildrenTable from "./ChildrenTable";
import CloseIcon from "@mui/icons-material/Close";
import { CircularProgress } from "@mui/material";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { call } from "services/axiosService/core";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import PersonIcon from "@mui/icons-material/Person";
import Avatar from "@mui/material/Avatar";
import MDButton from "components/MDButton";
import ChangePassword from "./ChangePassword";
import ManageSubscription from "./ManageSubscription";
import ManagePaymentMethods from "./ManagePaymentMethods";
import { useNavigate, useLocation } from "react-router-dom";

// Otis Admin PRO React contexts
import { useMaterialUIController, setProfile, setPersona } from "context";
import Snackbar from "@mui/material/Snackbar";
import * as Sentry from "@sentry/browser";
import MuiAlert from "@mui/material/Alert";
import { useTranslation } from "react-i18next";
import { set } from "react-hook-form";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

// const useQuery = () => {
//   const { search } = useLocation();
//   return useMemo(() => new URLSearchParams(search), [search]);
// };

const RequiredLabel = ({ children }) => {
  const { t } = useTranslation();
  return (
    <FormLabel
      sx={{
        display: "flex",
        color: "black",
        alignItems: "center",
        margin: "10px auto 2px",
        fontSize: "1.05rem",
        fontWeight: 900,
      }}
    >
      <span style={{ color: "red", fontSize: "small", marginRight: "5px" }}>*</span>
      {children}
      <span style={{ color: "red", fontSize: "small", marginLeft: "10px" }}>
        {t("formLabels.required")}
      </span>
    </FormLabel>
  );
};

const GuardianProfile = () => {
  const { t } = useTranslation();
  const location = useLocation();
  // let query = useQuery();
  const open_payment = location.state?.openPayment || false;
  const add_child = location.state?.openAddChild || false;
  const open_manage_payment_method = location.state?.openManagePaymentMethod || false;
  // const add_child = query.get("openAddChild") ? query.get("openAddChild") : "false";
  // const open_payment = query.get("openpayment") ? query.get("openpayment") : "false";
  const [openAddChild, setOpenAddChild] = useState(add_child);
  const [openPayment, setOpenPayment] = useState(open_payment);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [children, setChildren] = useState([]);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [openProfilePictureModal, setOpenProfilePictureModal] = useState(false);
  const [controller, dispatch] = useMaterialUIController();
  const { profile, persona } = controller;
  const [title, setTitle] = useState(t("profileInfo.guardian"));
  const [loader, setLoader] = useState(true);
  const [openChangePasswordDialog, setOpenChangePasswordDialog] = useState(false);
  const [openSubscriptionDialog, setOpenSubscriptionDialog] = useState(false);
  const [openManagePaymentMethodModal, setOpenManagePaymentMethodModal] = useState(
    open_manage_payment_method
  );
  const [openConvertToLearnerModal, setOpenConvertToLearnerModal] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [severity, setSeverity] = useState("success");
  const [alertMessage, setAlertMessage] = useState("");

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbar(false);
  };

  const handleCloseManagePaymentMethodModal = () => {
    setOpenManagePaymentMethodModal(false);
  };

  const handleCloseConvertToLearnerModal = () => {
    setOpenConvertToLearnerModal(false);
  };

  const openProfilePictureModalHandler = () => {
    setOpenProfilePictureModal(true);
  };

  const closeProfilePictureModal = () => {
    setOpenProfilePictureModal(false);
  };

  const openEditModalHandler = () => {
    setOpenEditModal(true);
  };

  const closeEditModal = () => {
    setOpenEditModal(false);
  };

  useEffect(() => {
    if (persona != "admin" && persona != "contentManager") {
      getChildrens();
    }
    setName(profile.details.name ?? "");
    setEmail(profile.email ?? "");
  }, []);

  useEffect(() => {
    switch (persona) {
      case "admin":
        setTitle(t("profileInfo.admin"));
        return;
      case "guardian":
        setTitle(t("profileInfo.guardian"));
        return;
      case "contentManager":
        setTitle(t("profileInfo.contentManager"));
        return;
      default:
        setTitle(t("profileInfo.guardian"));
        return;
    }
  });

  const getChildrens = () => {
    setLoader(true);
    call(`users/${profile.id}`, "GET", { params: { type: "children" } })
      .then((response) => {
        if (response.status == 200) {
          if (persona == "adultAthlete") {
            setChildren([profile, ...response.data]);
          } else {
            setChildren(response.data);
          }
          setLoader(false);
        }
      })
      .catch(function (error) {
        Sentry.captureException(error);
        console.log(error);
        setLoader(false);
      });
  };

  return (
    <DashboardLayout>
      <DashboardNavbar title={t("pageTitles.profile", { name: name.split(" ")[0] ?? "" })} />
      <Grid item xs="10" mt={2}>
        <Card style={{ padding: "30px" }}>
          <Grid display="flex" gap={3} alignItems="center">
            <Grid item style={{ position: "relative", paddingRight: "10px" }}>
              {profile.profile_image_url == null ? (
                <Avatar
                  alt={t("imageAlts.athleteImage")}
                  shadow="sm"
                  sx={{ height: "90px", width: "90px" }}
                >
                  <PersonIcon sx={{ height: "85px", width: "85px" }} color="white" />
                </Avatar>
              ) : (
                <MDAvatar
                  src={profile.profile_image_url}
                  alt={t("imageAlts.athleteImage")}
                  size="xxl"
                  shadow="sm"
                />
              )}
              <EditIcon
                onClick={openProfilePictureModalHandler}
                style={{
                  position: "absolute",
                  top: 0,
                  right: 0,
                  cursor: "pointer",
                  color: "#10B0D5",
                }}
              />
            </Grid>

            <Grid item xs="8">
              <MDBox height="100%" mt={0.5} lineHeight={1}>
                <MDTypography variant="h4" fontWeight="medium">
                  {name}
                </MDTypography>
                <MDTypography variant="h5" color="text" fontWeight="regular">
                  {title}
                </MDTypography>
              </MDBox>
            </Grid>
          </Grid>

          <MDTypography variant="h4" mt={1} mb={2}>
            {t("headings.profileInformation")}
          </MDTypography>

          {/* <MDTypography variant="h4" mt={1} mb={2}>
            Profile Information
          </MDTypography> */}
          <MDBox display="flex" justifyContent="" gap="10px">
            <MDTypography variant="p" fontSize={15} mb={1} ml={2}>
              <b>{t("profileInfo.name")}: </b>
              {name}
            </MDTypography>
            <EditIcon
              onClick={openEditModalHandler}
              style={{ marginLeft: "10px", cursor: "pointer", color: "#10B0D5" }}
            />
          </MDBox>
          <MDTypography variant="p" fontSize={15} mb={1} ml={2}>
            <b>{t("profileInfo.email")}: </b>
            {email}
          </MDTypography>
          <MDBox display="flex" justifyContent="flex-start" m={0}>
            <MDButton
              variant="contained"
              color="primary"
              style={{ width: 250, marginLeft: 15 }}
              onClick={() => {
                setOpenChangePasswordDialog(true);
              }}
              sx={{
                backgroundColor: "#10B0D5",
                color: "#fff",
                "&:hover": {
                  backgroundColor: "#089ebe",
                  color: "#fff",
                },
                textTransform: "none",
                fontSize: "14px",
                borderRadius: "12px",
                px: 3,
                py: 1.5,
              }}
            >
              {t("buttonTitles.changePassword")}
            </MDButton>

            <MDButton
              variant="contained"
              color="primary"
              style={{ width: 250, marginLeft: 15 }}
              onClick={() => {
                setOpenSubscriptionDialog(true);
              }}
              sx={{
                backgroundColor: "#10B0D5",
                color: "#fff",
                "&:hover": {
                  backgroundColor: "#089ebe",
                  color: "#fff",
                },
                textTransform: "none",
                fontSize: "14px",
                borderRadius: "12px",
                px: 3,
                py: 1.5,
              }}
            >
              {t("buttonTitles.manageSubscription")}
            </MDButton>

            {persona != "admin" && persona != "contentManager" && (
              <MDButton
                variant="contained"
                color="primary"
                style={{ width: 250, marginLeft: 15 }}
                onClick={() => {
                  setOpenManagePaymentMethodModal(true);
                }}
                sx={{
                  backgroundColor: "#10B0D5",
                  color: "#fff",
                  "&:hover": {
                    backgroundColor: "#089ebe",
                    color: "#fff",
                  },
                  textTransform: "none",
                  fontSize: "14px",
                  borderRadius: "12px",
                  px: 3,
                  py: 1.5,
                }}
              >
                {t("buttonTitles.managePaymentMethods")}
              </MDButton>
            )}

            {persona != "admin" && persona != "contentManager" && persona != "adultAthlete" && (
              <MDButton
                variant="contained"
                color="primary"
                style={{ width: 250, marginLeft: 15 }}
                onClick={() => {
                  setOpenConvertToLearnerModal(true);
                }}
                sx={{
                  backgroundColor: "#10B0D5",
                  color: "#fff",
                  "&:hover": {
                    backgroundColor: "#089ebe",
                    color: "#fff",
                  },
                  textTransform: "none",
                  fontSize: "14px",
                  borderRadius: "12px",
                  px: 3,
                  py: 1.5,
                }}
              >
                {t("buttonTitles.convertToLearner")}
              </MDButton>
            )}
          </MDBox>
          {persona != "admin" && persona != "contentManager" && (
            <ChildrenTable
              key={openPayment ? "payment-mode" : "default-mode"}
              childrenDetails={children}
              getChildrens={getChildrens}
              loader={loader}
              openAddChild={openAddChild}
              openPayment={openPayment}
            />
          )}
        </Card>
      </Grid>

      {openProfilePictureModal && (
        <ProfilePictureDialog
          openProfilePictureModal={openProfilePictureModal}
          closeProfilePictureModal={closeProfilePictureModal}
          profile={profile}
          t={t}
        />
      )}

      {openEditModal && (
        <ProfileEditDialog
          openEditModal={openEditModal}
          closeEditModal={closeEditModal}
          profile={profile}
          setName={setName}
        />
      )}

      {openChangePasswordDialog && (
        <ChangePassword
          openChangePasswordDialog={openChangePasswordDialog}
          setOpenChangePasswordDialog={setOpenChangePasswordDialog}
          setOpenSnackbar={setOpenSnackbar}
          setSeverity={setSeverity}
          setAlertMessage={setAlertMessage}
        />
      )}

      {openSubscriptionDialog && (
        <ManageSubscription
          openSubscriptionDialog={openSubscriptionDialog}
          setOpenSubscriptionDialog={setOpenSubscriptionDialog}
          setOpenSnackbar={setOpenSnackbar}
          setSeverity={setSeverity}
          setAlertMessage={setAlertMessage}
        />
      )}

      {openManagePaymentMethodModal && (
        <ManagePaymentMethods
          handleCloseManagePaymentMethodModal={handleCloseManagePaymentMethodModal}
          setOpenSnackbar={setOpenSnackbar}
          setSeverity={setSeverity}
          setAlertMessage={setAlertMessage}
          t={t}
        />
      )}

      {openConvertToLearnerModal && (
        <ConvetToLearnerDialog
          profile={profile}
          setProfile={setProfile}
          dispatch={dispatch}
          children={children}
          setPersona={setPersona}
          setChildren={setChildren}
          setOpenPayment={setOpenPayment}
          handleCloseConvertToLearnerModal={handleCloseConvertToLearnerModal}
          setOpenSnackbar={setOpenSnackbar}
          setAlertMessage={setAlertMessage}
          setSeverity={setSeverity}
          t={t}
        />
      )}

      <Snackbar
        autoHideDuration={5000}
        open={openSnackbar}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert onClose={handleCloseSnackbar} severity={severity} sx={{ width: "100%" }}>
          {alertMessage}
        </Alert>
      </Snackbar>
    </DashboardLayout>
  );
};

const ProfilePictureDialog = ({
  openProfilePictureModal,
  closeProfilePictureModal,
  profile,
  t = { t },
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [controller, dispatch] = useMaterialUIController();

  const removePhotoHanler = () => {
    setIsLoading(true);
    profile.profile_image_url = null;
    call(`users/${profile.id}`, "PUT", { body: profile })
      .then((res) => {
        if (res.status == 200) {
          setProfile(dispatch, profile);
          setIsLoading(false);
          closeProfilePictureModal(null);
        } else if (res.status == 440) {
          setIsLoading(false);
          closeProfilePictureModal(null);
        } else {
          console.log("error while updating user");
        }
      })
      .catch((err) => {
        console.log(err);
        Sentry.captureException(err);
        setIsLoading(false);
        closeProfilePictureModal();
      });
  };

  const uploadPhotoHandler = (e) => {
    setIsUploading(true);
    const data = new FormData();
    data.append("file", e.target.files[0]);
    const params = {
      upload: "image",
    };
    const headers = {
      accept: "application/json",
      "Accept-Language": "en-US,en;q=0.8",
      "Content-Type": "multipart/form-data",
    };

    call(`users/${profile.id}`, "PUT", { headers: headers, body: data, params: params })
      .then((res) => {
        if (res.status == 200) {
          profile.profile_image_url = res.data.profile_image_url;
          setProfile(dispatch, profile);
          setIsUploading(false);
          closeProfilePictureModal();
        } else if (res.status == 440) {
          setIsUploading(false);
          closeProfilePictureModal();
        }
      })
      .catch((err) => {
        console.log(err);
        Sentry.captureException(err);
        setIsUploading(false);
        closeProfilePictureModal();
      });
  };

  return (
    <Dialog open={openProfilePictureModal} onClose={closeProfilePictureModal}>
      <CloseIcon
        fontSize="medium"
        onClick={closeProfilePictureModal}
        style={{ color: "red", display: "block", marginLeft: "auto", cursor: "pointer" }}
      />
      <DialogTitle>
        <MDTypography variant="h4" mb={3}>
          {t("headings.uploadProfilePicture")}
        </MDTypography>
      </DialogTitle>

      <DialogContent>
        <Grid container justify="flex-start">
          <Grid item style={{ position: "relative", paddingRight: "10px" }}>
            {profile.profile_image_url == null ? (
              <Avatar
                alt={t("imageAlts.athleteImage")}
                shadow="sm"
                sx={{ height: "90px", width: "90px" }}
              >
                <PersonIcon sx={{ height: "85px", width: "85px" }} color="white" />
              </Avatar>
            ) : (
              <MDAvatar
                src={profile.profile_image_url}
                alt={t("imageAlts.athleteImage")}
                size="xxl"
                shadow="sm"
              />
            )}
          </Grid>
          <Grid item>
            <button
              style={{
                display: "block",
                width: "120px",
                height: "30px",
                margin: "15px 10px 10px 10px",
                color: "white",
                background: "#F6821E",
              }}
              onClick={() => {
                document.getElementById("getFile").click();
              }}
            >
              {isUploading ? t("buttonTitles.uploading") : t("buttonTitles.uploadPhoto")}
            </button>
            <input
              type="file"
              id="getFile"
              accept=".png, .jpg, .jpeg, .svg, .ico, .gif"
              onChange={uploadPhotoHandler}
              style={{ display: "none" }}
            ></input>
            {profile.profile_image_url != null && (
              <button
                style={{
                  display: "block",
                  width: "120px",
                  height: "30px",
                  margin: "10px",
                  color: "white",
                  background: "#d4242d",
                }}
                onClick={removePhotoHanler}
              >
                {isLoading ? t("buttonTitles.removing") : t("buttonTitles.removePhoto")}
              </button>
            )}
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

const ProfileEditDialog = ({ openEditModal, closeEditModal, profile, setName }) => {
  const { t } = useTranslation();
  const [controller, dispatch] = useMaterialUIController();
  const [firstName, setFirstName] = useState(profile.details.name.split(" ")[0] ?? "");
  const [lastName, setLastName] = useState(profile.details.name.split(" ")[1] ?? null);

  const editSubmitHandler = (e) => {
    e.preventDefault();
    const nameValue = firstName + " " + lastName;
    const body = {
      pk: profile.pk ?? "user",
      sk: profile.sk ?? `user[${profile.id}]`,
      details: {
        address: {
          city: profile.details.address.city,
          country: profile.details.address.country,
          state: profile.details.address.state,
          street: profile.details.address.street,
          zip: profile.details.address.zip,
        },
        dob: profile.details.dob,
        persona: profile.details.persona ?? null,
        name: nameValue,
        gender: profile.details.gender ?? null,
      },
      email: profile.email,
      phone: profile.phone,
      id: profile.id,
      cognito_user_id: profile.cognito_user_id,
      identities: profile.identities,
      profile_image_url: profile.profile_image_url,
      relationships: profile.relationships,
      status: profile.status,
      payment_status: profile.payment_status,
      type: profile.type,
    };

    call(`users/${profile.id}`, "PUT", { body: body })
      .then((res) => {
        if (res.status == 200) {
          closeEditModal();
          setProfile(dispatch, body);
          setName(res.data.ModifiedAttributes.details.name);
        } else if (res.status == 440) {
          closeEditModal();
        }
      })
      .catch((err) => {
        Sentry.captureException(err);
        console.log(err);
      });
  };
  return (
    <Dialog open={openEditModal} onClose={closeEditModal}>
      <CloseIcon
        fontSize="medium"
        onClick={closeEditModal}
        style={{ color: "red", display: "block", marginLeft: "auto", cursor: "pointer" }}
      />
      <DialogTitle>
        <MDTypography variant="h4" mb={1}>
          {t("headings.editProfile")}
        </MDTypography>
      </DialogTitle>

      <form onSubmit={editSubmitHandler}>
        <DialogContent>
          <RequiredLabel>{t("formLabels.firstName")}</RequiredLabel>
          <MDInput
            rows="1"
            name="firstname"
            type="text"
            value={firstName}
            onChange={(e) => {
              if (e.nativeEvent.data != " ") {
                setFirstName(e.target.value);
              }
            }}
            multiline
            fullWidth
            required
          />
          <RequiredLabel>{t("formLabels.lastName")}:</RequiredLabel>
          <MDInput
            rows="1"
            name="lastname"
            type="text"
            value={lastName}
            onChange={(e) => {
              if (e.nativeEvent.data != " ") {
                setLastName(e.target.value);
              }
            }}
            multiline
            fullWidth
            required
          />
        </DialogContent>
        <DialogActions>
          <Button
            type="submit"
            style={{
              color: "white",
              background: "#10B0D5",
              display: "block",
            }}
          >
            {t("buttonTitles.saveChanges")}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

const ConvetToLearnerDialog = ({
  profile,
  setProfile,
  dispatch,
  children,
  setPersona,
  setChildren,
  handleCloseConvertToLearnerModal,
  setOpenSnackbar,
  setAlertMessage,
  setSeverity,
  setOpenPayment,
  t,
}) => {
  const [loading, setLoading] = useState(false);

  const convertMeToLearner = () => {
    call(`users/${profile.id}/convert-to-learner`, "PUT", {})
      .then((response) => {
        if (response.status == 200) {
          setProfile(dispatch, response.data.user_details);
          setPersona(dispatch, "adultAthlete");
          setChildren([response.data.user_details, ...children]);
          setOpenSnackbar(true);
          setSeverity("success");
          setAlertMessage("Successfully converted to learner");
          handleCloseConvertToLearnerModal();
          setTimeout(() => setOpenPayment(true), 100);
        } else {
          setOpenSnackbar(true);
          setSeverity("error");
          setAlertMessage("Error while converting to learner");
        }
      })
      .catch(function (error) {
        Sentry.captureException(error);
        console.log(error);
        setOpenSnackbar(true);
        setSeverity("error");
        setAlertMessage("Error while converting to learner");
      });
  };

  return (
    <Dialog open={true} onClose={handleCloseConvertToLearnerModal}>
      <CloseIcon
        fontSize="medium"
        onClick={handleCloseConvertToLearnerModal}
        style={{ color: "red", display: "block", marginLeft: "auto", cursor: "pointer" }}
      />
      <DialogContent>
        <Typography
          variant="body1"
          fontSize={20}
          sx={{ whiteSpace: "normal", lineHeight: 1.7 }}
          mb={2}
          dangerouslySetInnerHTML={{ __html: t("instructionToConvertToLearner.info") }}
        ></Typography>
      </DialogContent>
      <DialogActions>
        <MDButton
          variant="contained"
          color="primary"
          style={{ width: 150, marginLeft: 15 }}
          onClick={() => {
            convertMeToLearner();
          }}
          sx={{
            backgroundColor: "#10B0D5",
            color: "#fff",
            "&:hover": {
              backgroundColor: "#089ebe",
              color: "#fff",
            },
            textTransform: "none",
            fontSize: "14px",
            borderRadius: "12px",
            px: 3,
            py: 1.5,
          }}
        >
          {loading ? <CircularProgress size={22} color="inherit" /> : "Yes"}
        </MDButton>
        <MDButton
          variant="contained"
          color="primary"
          style={{ width: 150, marginLeft: 15 }}
          onClick={handleCloseConvertToLearnerModal}
          sx={{
            backgroundColor: "#f2164d",
            color: "#fff",
            "&:hover": {
              backgroundColor: "#f25e83",
              color: "#fff",
            },
            textTransform: "none",
            fontSize: "14px",
            borderRadius: "12px",
            px: 3,
            py: 1.5,
          }}
        >
          No
        </MDButton>
      </DialogActions>
    </Dialog>
  );
};
export default GuardianProfile;
